import axios from "axios";

const endPoint = 'https://restcountries.com/v3.1/';

export const getCountries = ()=> {
    return axios.get(`${endPoint}/all`);
}